import { Body, DialogContent, DialogProps, Textarea } from '@indigo-ag/component-module';
import i18next from 'core/i18n';
import React, { useEffect, useState } from 'react';

import { EnhancedDialog, ModalActionButtons, utils } from 'shared';

interface PriorityModalProps extends DialogProps {
  title: string;
  message: string;
  closeModal: () => void;
  onConfirmAction: (newPriority: boolean, notes: string | null) => Promise<any>;
  notesRequired?: boolean;
}

export const PriorityModal: React.FunctionComponent<PriorityModalProps> = ({
  title,
  message,
  closeModal,
  open,
  onConfirmAction,
  notesRequired = false,
  children
}) => {
  /**
   * State
   */
  const [notes, setNotes] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setNotes('');
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const onNotesChange = (e: React.ChangeEvent<any>) => {
    setNotes(e.target.value);

    if (notesRequired && !e.target.value) {
      setError(i18next.t('provideNote'));
    } else if (notesRequired && e.target.value) {
      setError('');
    }
  };

  const handleSave = () => {
    return onConfirmAction(true, notes);
  };

  const notesLabel = `${i18next.t('notes')} (${notesRequired ? i18next.t('required') : i18next.t('optional')})`;

  const canSave = (notesRequired && !!notes) || !notesRequired ? true : false;

  return (
    <EnhancedDialog open={open} onClose={closeModal} title={title} dialogMaxWidth="480px">
      <DialogContent>
        <div style={{ marginTop: 30 }}>
          {children}
          <Body>{utils.text.firstLetterUppercase(message)}</Body>
          <Textarea label={notesLabel} onChange={onNotesChange} value={notes} error={error} />
        </div>
      </DialogContent>
      <ModalActionButtons
        closeModal={closeModal}
        save={handleSave}
        changeButtonName={i18next.t('save')}
        disabled={!canSave}
      />
    </EnhancedDialog>
  );
};
